module.exports = __webpack_public_path__ + "img/mockup_hospital@2x.bfac6f26.png";